import { render, staticRenderFns } from "./SalesRep.vue?vue&type=template&id=c15a37fa&scoped=true"
import script from "./SalesRep.vue?vue&type=script&lang=ts"
export * from "./SalesRep.vue?vue&type=script&lang=ts"
import style0 from "./SalesRep.vue?vue&type=style&index=0&id=c15a37fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15a37fa",
  null
  
)

export default component.exports